import { useRouter } from 'next/router'
import LinkWithoutPrefetch from 'shared/components/link-without-prefetch'
import useUser from 'shared/hooks/use-user'
import { getDefaultDashboardUrl } from 'shared/utils/get-default-dashboard-url'
import {
  getBrandFromLocalStorage,
  isClient,
  isSioHost,
  defaultBrandSettings,
} from '@systemeio/util'
import { useMetadataFromServer } from 'shared/hooks/use-metadata-from-server'
import { useEffect, useState } from 'react'

const SioButton = () => {
  const router = useRouter()
  const { user, isDisabled } = useUser()
  const { data: metaDataFromServer } = useMetadataFromServer()

  const [hydrated, setHydrated] = useState(false)
  useEffect(() => {
    setHydrated(true)
  }, [])

  const logoLoader = (
    <div className="bg-text-secondary h-[35px] min-h-[35px] w-[35px] min-w-[35px] animate-pulse rounded-full"></div>
  )

  const getLogoImage = (
    src: string = defaultBrandSettings.logo?.path,
    alt: string = defaultBrandSettings.name,
  ) => {
    return (
      <img
        className="h-[35px] min-h-[35px] w-[35px] min-w-[35px] object-cover"
        src={src}
        alt={alt}
      />
    )
  }

  const getWlLogo = () => {
    if (isClient() && hydrated) {
      const brand = getBrandFromLocalStorage()
      if (brand) {
        return getLogoImage(brand.logo?.path, brand.name)
      }
    }
  }

  const getSioLogo = () => {
    if (isClient()) {
      if (isSioHost(window.location.host)) {
        return getLogoImage()
      }
    } else {
      if (metaDataFromServer?.hostOnServer && isSioHost(metaDataFromServer.hostOnServer)) {
        return getLogoImage()
      }
    }
  }

  const getLogo = () => {
    return getSioLogo() ?? getWlLogo() ?? logoLoader
  }

  return user && !isDisabled ? (
    <button
      className={'ring-background-secondary rounded-full ring-offset-0 focus-visible:ring-2'}
      onClick={() => router.push(getDefaultDashboardUrl(user))}
    >
      <LinkWithoutPrefetch
        className={'tab focus:outline-hidden'}
        tabIndex={-1}
        href={getDefaultDashboardUrl(user)}
      >
        {getLogo()}
      </LinkWithoutPrefetch>
    </button>
  ) : (
    getLogo()
  )
}

export default SioButton
